import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import base_URL from "../base_URL";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
     
      {"Developed by  " }  
      <Link color="inherit" href="https://www.linkedin.com/in/kuldeep-mewara/">
       Kuldeep Mewara
      </Link>{" ❤️ "} 
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);

const InvalidEmail = () => {
  toast.error("Invalid Email");
};

const InvalidCredential = () => {
  toast.error("Credential did't match");
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: "url(https://source.unsplash.com/random)",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  bt: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export default function SignInSide() {
  const classes = useStyles();

  const [user, setUser] = useState([]);

  const handleForm = (e) => {
    if (!validEmailRegex.test(user.email)) {
      InvalidEmail();
    } else {
      postDataToServer(user);
    }
    e.preventDefault();
  };

  const postDataToServer = (data) => {
    axios
      .post(`${base_URL}/verifyuser`, data)

      .then(
        (response) => {
        
          if(JSON.parse(JSON.stringify(response.data.roles))=="ADMIN")
          {localStorage.setItem("Admin1token", JSON.stringify(response.data));
          window.location.href = "/admin";
         }
          else{
          localStorage.setItem("token", JSON.stringify(response.data));
          window.location.href = "/welcome";
          }
        },
        (error) => {
          console.log(data);
          console.log("error");
          InvalidCredential();
        }
      );
  };

  return (
    <Grid container component="main" className={classes.root} id="login">
      <ToastContainer />
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}></Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <form className={classes.form} onSubmit={handleForm}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={(e) => {
                setUser({ ...user, email: e.target.value });
              }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={(e) => {
                setUser({ ...user, password: e.target.value });
              }}
            />

            <input
              type="submit"
              margin="normal"
              fullWidth
              variant="contained"
              value="Sign In"
              class="btn  btn-primary mt-2 mb-2"
            />

            </form>

            <Box>
              <Link href="/register" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Box>

            <Box mt={3}>
              <Copyright />
            </Box>
          
        </div>
      </Grid>
    </Grid>
  );
}
